var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var white = "#ffffff";
var black = "#000000";

var grayScale = {
  gray100: "#F1F3F4",
  gray300: "#DEE2E6",
  gray500: "#6C757D",
  gray900: "#202124"
};

var primary = {
  primary100: "#DAF3FF",
  primary500: "#228BE6",
  primary800: "#3C48AA",
  primary900: "#1D6BB7"
};

var secondary = {
  secondary100: "#DEE2E6",
  secondary500: "#6C757D",
  secondary900: "#202124"
};

var danger = {
  danger100: "#FFECEE",
  danger500: "#E70202",
  danger900: "#AC0000"
};

var warning = {
  warning100: "#FEF6D5",
  warning500: "#FCC530",
  warning900: "#C59500"
};

var success = {
  success100: "#D3F8E5",
  success500: "#02883C",
  success900: "#005A11"
};

var blue = {
  blue500: "#3A97E9"
};

var yellow = {
  yellow500: "#FDBB49"
};

var green = {
  green500: "#02A749",
  green700: "#709730"
};

var red = {
  red400: "#FD5D5D"
};

var purple = {
  purple300: "#8985FF"
};

var brown = {
  brown400: "#D66D0A"
};

var pink = {
  pink500: "#E660C0"
};

var misc = {
  bodyBg: white,
  bodyColor: grayScale.gray900,
  default: grayScale.gray100,
  primary: primary.primary500,
  secondary: secondary.secondary500,
  warning: warning.warning500,
  success: success.success500,
  blue: blue.blue500,
  yellow: yellow.yellow500,
  green: green.green500,
  red: red.red400,
  purple: purple.purple300,
  brown: brown.brown400,
  pink: pink.pink500,
  danger: danger.danger500,
  link: primary.primary500,
  bgCard: white,
  shadows: black,
  light: grayScale.gray100,
  gray: grayScale.gray500,
  dark: grayScale.gray900
};

export var colors = _extends({
  white: white,
  black: black
}, grayScale, primary, secondary, warning, success, blue, yellow, green, red, purple, brown, pink, danger, misc);

export var fontStack = {
  default: "museo-sans,sans-serif"
};

export var typography = {
  headings: {
    xs: "16px",
    sm: "20px",
    md: "24px",
    lg: "32px",
    xl: "48px"
  },
  subHeadings: {
    sm: "12px",
    md: "14px",
    lg: "16px"
  },
  text: {
    xs: "10px",
    sm: "12px",
    md: "14px",
    lg: "16px",
    xl: "20px"
  },
  icons: {
    xs: "14px",
    sm: "16px",
    md: "20px",
    lg: "24px",
    xl: "28px"
  }
};

export var fontWeight = {
  light: "300",
  regular: "300",
  semiBold: "500",
  bold: "700"
};

export var spacings = {
  none: "0",
  xxs: "4px",
  xs: "8px",
  sm: "12px",
  md: "16px",
  lg: "24px",
  xl: "32px",
  xxl: "40px"
};

export var breakpoints = {
  xs: "@media (min-width: 0)",
  sm: "@media (min-width: 768px)",
  md: "@media (min-width: 1024px)",
  lg: "@media (min-width: 1200px)",
  xl: "@media (min-width: 2400px)"
};

export var transition = "0.3s ease";

export var borderRadius = {
  none: "0",
  sm: "4px",
  md: "8px",
  lg: "12px"
};

export var form = {
  heightSize: {
    sm: "28px",
    md: "38px",
    lg: "44px"
  }
};